import React, { Component } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

class Home extends Component {
    render() {
      window.scrollTo({ top: 0, behavior: "auto",});
        return(
            <div className="my-auto">
                <Slideshow/>
                <div id="home-info" className="mt-3 d-flex home-content" style={{ "width": "80vw", "marginLeft": "10vw"}}>
            <h2 className="d-flex" style={{"justifyContent" : "center"}}>Прием на военную кафедру ТУМ</h2>
            <hr style={{"width":"80vw", "height" : "3px", "borderWidth": "0", "backgroundColor": "#0f0f0f"}}/>
            <p>На военную кафедру <span className="text-hl">ТУМ (Технического университета Молдовы)</span> проходит набор студентов и выпускников высших учебных заведений, учащихся колледжей и выпускников колледжей.</p>
            <br/>
            <p><span className="text-hl">Физическая запись</span> на кафедру (с документами указанными ниже) возможна в:</p>
            <ul style={{"alignContent": "start"}}>
            <li>в 3-ем блоке, кабинет 403 <span className="text-hl"> (Рышкановка)</span></li>
            {/* <li>в 10-м блоке, второй этаж <span className="text-hl">(Ботаника)</span></li> */}
            </ul>
            <br/>
            <p><span className="text-hl">Срок обучения: сентябрь - декабрь или февраль - июнь</span></p>
            <p>Также можно записаться <span className="text-hl">онлайн</span>, прислав соответствующие документы на <span className="text-hl">E-mail</span> или <span className="text-hl">Viber</span> указаные ниже</p>
            
            <br/>
            <p className="text-hl" style={{"fontSize": "140%"}}>Список необходимых документов:</p>
            <ul style={{"color": "#2d2b30"}}>
              <li><a href="assets/docs/Cerere_UTM_online.doc" target="_blank" rel="noopener noreferrer">Заявление</a> на зачисление на военную кафедру</li>
              <li><a href="assets/docs/Contract_UTM_online.doc" target="_blank" rel="noopener noreferrer">Контракт</a> "На рассмотрение на обучение на военную кафедру ТУМ"</li>
              <li>Копия (<a href="assets/docs/buletin_model.jpg" target="_blank" rel="noopener noreferrer">скриншот</a>) булетина</li>
              <li>Копия (<a href="assets/docs/Recrut_model.jpg" target="_blank" rel="noopener noreferrer">скриншот</a>) Предписного свидетельства (для мужчин)</li>
              <li>Заявление (<a href="assets/docs/Declaratia.jpg" target="_blank" rel="noopener noreferrer">скриншот</a>) о наличии необходимого оборудования для проведения занятий онлайн</li>
              <li>Форма (<a href="assets/docs/Aviz.jpg" target="_blank" rel="noopener noreferrer">скриншот</a>) для оплаты обучения на военной кафедре</li>
              <li>Сертификат об обучении или копия диплома (для выпускников или студентов других университетов или колледжей)</li>
            </ul>
            <p className="text-hl" style={{"fontSize": "140%"}}>Куда отправлять документы:</p>
              <ul>
              <li>E-mail: <a href="mailto:bulatviktor.64@gmail.com">bulatviktor.64@gmail.com</a></li>
              <li>По телефонам <span className="text-hl">(Viber)</span>: <br className="d-sm-none"/> <a href="tel:+37379702363">+(373) 079 702363</a> или <br className="d-sm-none"/> <a href="tel:+37368690955">+(373) 068 690955</a></li>
              <li>Телефон Военной кафедры: <br className="d-sm-none"/> <a href="tel:+373022924532">+(373) 022 92-45-32</a></li>
              </ul>
            <p><span className="text-hl">Полковник Булат Виктор Петрович</span></p>

             {/* <p>Также есть сообщество в <a href="https://www.facebook.com/"target="_blank" rel="noopener noreferrer">Facebook</a>.</p> */}
            </div>
            </div>
        );
    }
}

const slideStyle = (index) => {return ({
    "display" : "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundImage": `url(${slideImages[index]})`,
    "backgroundSize": "cover",
    "backgroundPosition": "center center",
    "height": "75vh"
  })};

  const slideImages = [
    "assets/images/IMG_3973-min.jpg",
    "assets/images/IMG_3974-min.jpg",
    "assets/images/IMG_3975-min.jpg",
    "assets/images/IMG_3977-min.jpg",
    "assets/images/IMG_3978-min.jpg",
    "assets/images/IMG_4477-min.jpg",
    "assets/images/IMG_4500-min.jpg",
    "assets/images/IMG_4505-min.jpg",
    "assets/images/IMG_4507-min.jpg",
  ];

class Slideshow extends Component {
    constructor(props) {
      super(props);
      this.slideRef = React.createRef();
    //   this.back = this.back.bind(this);
    //   this.next = this.next.bind(this);
      this.state = {
        current: 0
      };
    }
  
    // back() {
    //   this.slideRef.current.goBack();
    // }
  
    // next() {
    //   this.slideRef.current.goNext();
    // }
  
    render() {
      const properties = {
        transitionDuration: 500,
        arrows: false,
        easing: "ease",
        //prevArrow: <div style={{width: "30px", marginRight: "-30px", fontSize: "200%"}}><span className="fa fa-arrow-circle-left fa-lg" style={{border: "3px solid #ffffff", borderRadius: "50%", backgroundColor: "#ffffff"}}></span></div>,
        //nextArrow: <div style={{width: "30px", marginLeft: "-30px", fontSize: "200%"}}><span className="fa fa-arrow-circle-right fa-lg" style={{border: "3px solid #ffffff", borderRadius: "50%", backgroundColor: "#ffffff"}}></span></div>
      };
      
      return (
          <div className="slide-container">
            <div className="slide-text">
              <div>Прием на военную кафедру оффлайн/онлайн!</div>
            <div id="scroll-btn"><a href="#home-info"><span></span></a></div>
            </div>
            <Slide ref={this.slideRef} {...properties}>
              {slideImages.map((each, index) => (
                <div key={index} className="each-slide">
                  {/* <img className="lazy" src={each} alt="sample"/> */}
                  <div style={slideStyle(index)}>
                      </div>
                </div>
              ))}
            </Slide>
          </div>
      );
    }
  }

export default Home;